import { UPDATE_SOUND_BROADCAST } from '../constants'

export const saveRule = (rule, onSave, soundStatus = false) => (_, getState) => {
    const { assetId, broadcastChannel, savedRules } = getState().editorReducer

    if (!assetId && assetId !== 0) return

    fetch(
        `/services/plugin-channel-alarms/alarm-rules/${assetId}/${
            soundStatus ? (rule.global ? 'global/sound' : 'sound') : rule.global ? 'allUsersRules' : 'userRules'
        }`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify([{ ...rule, global: undefined, ...(rule.new ? { id: undefined } : {}) }])
        }
    )
        .then(r => r.json())
        .then(r => {
            if (typeof onSave === 'function') {
                onSave(r.success ? 'success' : 'error', r.newAndModifiedRules, r.newRuleIds || [])

                if (r.success) {
                    if (r.newAndModifiedRules.length) {
                        const newRule = r.newAndModifiedRules[0]

                        if (rule.new || (savedRules[rule.index] && savedRules[rule.index].sound !== newRule.sound)) {
                            broadcastChannel.postMessage({
                                type: UPDATE_SOUND_BROADCAST,
                                status: { [newRule.id]: newRule.sound },
                                assetId
                            })
                        }
                    }
                } else {
                    console.error('Error saving ' + (soundStatus ? 'sound status' : 'rule') + ':', r.error)
                }
            } else {
                console.error(`Missing 'onSave' parameter when saving rule`)
            }
        })
        .catch(err => console.error('Error saving rules:', err))
}

export const saveRules = (userRules, allUsersRules, onSave, soundStatus = false, deleteRules = false) => (
    _,
    getState
) => {
    const { assetId, broadcastChannel, savedRules } = getState().editorReducer

    if (!assetId && assetId !== 0) return

    Promise.all(
        [
            userRules.length
                ? fetch(
                      `/services/plugin-channel-alarms/alarm-rules/${assetId}/${soundStatus ? 'sound' : 'userRules'}`,
                      {
                          method: deleteRules ? 'DELETE' : 'POST',
                          headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(userRules)
                      }
                  ).then(r => r.json())
                : null,
            allUsersRules.length
                ? fetch(
                      `/services/plugin-channel-alarms/alarm-rules/${assetId}/${
                          soundStatus ? 'global/sound' : 'allUsersRules'
                      }`,
                      {
                          method: deleteRules ? 'DELETE' : 'POST',
                          headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(allUsersRules)
                      }
                  ).then(r => r.json())
                : null
        ].filter(p => p)
    )
        .then(responses => {
            if (typeof onSave === 'function') {
                const success = responses.every(r => r.success)
                const error = responses.some(r => !r.success)

                const newAndModifiedRules = responses.reduce(
                    (rules, r) => (r.success ? [...rules, ...(r.newAndModifiedRules || [])] : rules),
                    []
                )
                onSave(success ? (error ? 'partial' : 'success') : 'error', newAndModifiedRules)

                if (error) {
                    console.error(
                        'Error ' +
                            (deleteRules ? 'deleting ' : 'saving ') +
                            (soundStatus ? 'sound status' : 'rules') +
                            ':',
                        responses.filter(r => !r.success).map(r => r.error)
                    )
                }

                if (!deleteRules && newAndModifiedRules.length) {
                    const newSoundStatus = newAndModifiedRules.reduce(
                        (status, rule) => ({
                            ...status,
                            ...(savedRules[rule.index] && savedRules[rule.index].sound !== rule.sound
                                ? { [rule.id]: rule.sound }
                                : {})
                        }),
                        {}
                    )

                    for (const rule of [...userRules, ...allUsersRules].filter(rule => rule.new)) {
                        const newRule = newAndModifiedRules.find(r => r.index === rule.index)

                        if (typeof newRule !== 'undefined') {
                            newSoundStatus[newRule.id] = newRule.sound
                        }
                    }

                    if (Object.keys(newSoundStatus).length) {
                        broadcastChannel.postMessage({
                            type: UPDATE_SOUND_BROADCAST,
                            status: newSoundStatus,
                            assetId
                        })
                    }
                }
            } else {
                console.error(`Missing 'onSave' parameter when ${deleteRules ? 'deleting' : 'saving'} rules`)
            }
        })
        .catch(err => console.error('Error saving rules:', err))
}
